const init = () => {

    var $navSearch = $('.c-nav-search');
    var $mobSearchToggle = $('.c-nav__search-btn');
    var $fieldToggle = $navSearch.find('.c-nav-search__field-btn');
    var $field = $('#search');
    var $body = $(document.body);

    // events
    PubSub.subscribe('app:resized', onResize);
    $fieldToggle.on('click', onFieldToggleClick);
    $field.on('blur', onFieldBlur);
    $field.on('focus', onFieldFocus);
    $mobSearchToggle.on('click', onMobSearchToggleClick);

    PubSub.subscribe('page-dimmer:clicked', onPageDimmerClick);
    function onPageDimmerClick() {
        $field.blur();
    }
    
    // only ever closes, unclickable in default state
    function onFieldToggleClick() {
        $field.val('');
        PubSub.publishSync('close-autocomplete');
        $field.blur();
    }

    function onResize() {
        // Check if we're on mobile (below tablet breakpoint)
        var isMobile = window.innerWidth < 768; // tablet breakpoint is 768px
        
        if (isMobile) {
            // On mobile, the search field width is controlled by CSS (100% !important)
            // We just need to ensure the search is closed on resize
            if (!$body.hasClass('search-open')) {
                $mobSearchToggle.removeClass('is-active');
            }
        } else {
            // On desktop/tablet, handle width changes
            if ($body.hasClass('search-open')) {
                growSearchField();
            } else {
                shrinkSearchField();
            }
        }
    }
    
    // only opens, search bar sits on top when in closed state
    function onMobSearchToggleClick(e) {
        $(this).addClass('is-active');
        $field.focus();
        PubSub.publish('close-nav');
        $body.addClass('search-open');
    };
    
    function onFieldBlur(e) {
        if (!$body.hasClass('autocomplete-open')) {
            $mobSearchToggle.removeClass('is-active');
            $body.removeClass('search-open');

            shrinkSearchField();
        }
    }

    function onFieldFocus(e) {
        $body.addClass('search-open');
        growSearchField();
        PubSub.publish('close-nav');
    }

    function growSearchField() {
        var $nav = $('.c-nav');
        var containerW = $nav.find('.c-nav__container').width();
        var logoOuterWidth = $nav.find('.c-nav__logo').outerWidth(true);
        var destW = containerW - logoOuterWidth - 6;
        $field.css('width', destW);
    }

    function shrinkSearchField() {
        var $placeholder = $navSearch.find('.c-nav-search__field-placeholder');
        if ($placeholder.length > 0 && $placeholder.is(':visible')) {
            var destW = $placeholder.width();
            $field.css('width', destW);
        } else {
            // Fallback: remove inline width to let CSS take over
            $field.css('width', '');
        }
    }

}

export default init;